import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import LiberacaoService from "../../services/LiberacaoService";
import CrudForm from "../../components/forms/custom/CrudForm";

class FormLiberacao extends CrudForm {

    constructor(props) {
        super(props);

        this.state.model = {
            idLiberacao: "",
            nome: ""
        };

        this.state.crud = {
            service: LiberacaoService,
            labels: {
                title: 'Liberação',
            },
            urlList: '/LstLiberacao',
        };
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">
                <InputText label="Código" md={3} value={this.state.model.idLiberacao} name="idLiberacao" readOnly opcionalLabel={false}/>
                <InputText label="Nome do Liberação" autoFocus={true} required md={9} value={this.state.model.nome} name="nome" onChange={this.handleChange} maxLength={100} />
            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    return <FormLiberacao {...props} navigate={navigate} params={params} />
}

export default With